import React, { useState, useEffect, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import Mark from "mark.js";

const SearchBox = () => {
  const [query, setQuery] = useState("");
  const markInstance = useRef(null);

  useEffect(() => {
    markInstance.current = new Mark(document.body);
    return () => markInstance.current.unmark();
  }, []);

  useEffect(() => {
    if (!query.trim()) {
      markInstance.current.unmark();
      return;
    }

    markInstance.current.unmark({
      done: () => markInstance.current.mark(query),
    });
  }, [query]);

  const handleClear = () => {
    setQuery("");
    markInstance.current.unmark();
  };

  return (
    <div className="relative">
      <input
        type="text"
        placeholder="Search..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="w-48 lg:w-56 py-2 pl-9 pr-8 border border-black rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
      />

      {/* Search Icon */}
      <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-black text-sm" />

      {/* Clear Button */}
      {query && (
        <button
          onClick={handleClear}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-500 text-sm"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchBox;
